import styled, { css } from "styled-components";
import { SearcherFliItem as OpenjawSearcherFliItem } from "../../components/openjaw-input/styled.js";
import { SearcherItem, SearcherTop } from "../../../searcher/styled.js";
import { ToggleInputWrapper, ToggleWrapper } from "../../../../../forms/inputs/toggle/styled.js";
import { FlexMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { FlexColumnMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const SearcherTopItem = styled(SearcherTop).withConfig({
    displayName: "styled__SearcherTopItem",
    componentId: "sc-511f031f-0"
})``;
export const SearcherItemArrayInput = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemArrayInput",
    componentId: "sc-511f031f-1"
})`
	flex-basis: 100%;
	max-width: 100%;

	${({ theme  })=>theme.media.up('md')} {
		flex-basis: 100%;
		max-width: 100%;
	}

	${({ theme  })=>theme.media.up('lg')} {
		flex-basis: 100%;
		max-width: 100%;
	}

	${({ theme  })=>theme.media.up('xl')} {
		flex-basis: 100%;
		max-width: 100%;
	}

	${({ theme , $onModal  })=>$onModal && css`
			${OpenjawSearcherFliItem} {
				${theme.media.up('md')} {
					flex-basis: calc((100% / 3) - var(--division-gap));
					flex-grow: 1;
					max-width: unset;
				}
			}
		`}
`;
export const SearcherFliItem = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherFliItem",
    componentId: "sc-511f031f-2"
})`
	${({ theme , $isOpenjaw  })=>$isOpenjaw ? css`
					${theme.media.up('sm')} {
						${FlexColumnMixin({
        columns: 2,
        gap: 'var(--division-gap)'
    })};
					}

					${theme.media.up('md')} {
						flex-basis: calc(((100% - 224px) / 4) - var(--division-gap));
						flex-grow: 1;
						max-width: unset;
					}

					${theme.media.up('lg')} {
						flex-grow: 1;
						flex-shrink: 0;
					}

					${theme.media.up('xl')} {
						flex-grow: 0;
					}
			  ` : ''}
	${({ $isToggle  })=>$isToggle ? css`
					display: flex;
			  ` : ''}
	${ToggleWrapper} {
		flex-direction: row-reverse;
		${ToggleInputWrapper} {
			margin-right: 10px;
		}
	}
`;
export const SearcherFliItemBreakingRow = styled(SearcherFliItem).withConfig({
    displayName: "styled__SearcherFliItemBreakingRow",
    componentId: "sc-511f031f-3"
})`
	${FlexMixin({
    justify: 'center'
})}
`;
export const SearcherFliOpenjawItem = styled(SearcherFliItem).withConfig({
    displayName: "styled__SearcherFliOpenjawItem",
    componentId: "sc-511f031f-4"
})``;

//# sourceMappingURL=styled.js.map